import React from "react";
import "../index.scss"
import { t } from "../../../../../utils/i18n";

const Head = () => (
  <thead className="bankaccountspage-tablehead">
    <tr className="bankaccountspage-tablehead-row">
      <th>{t("p2p.common.name")}</th>
      <th>{t("p2p.common.bank_name")}</th>
      <th>{t("p2p.common.account_number")}</th>
      <th className="bankaccountspage-table-actions">{t("p2p.common.actions")}</th>
    </tr>
  </thead>
);

export default Head;
